import { render, staticRenderFns } from "./ImportCertificate.vue?vue&type=template&id=ad1dfb96"
import script from "./ImportCertificate.vue?vue&type=script&lang=js"
export * from "./ImportCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports